import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "inverse"];
import React, { forwardRef } from 'react';
import { TextSmall } from '../typography';
var HelpText = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? 'This is the help text' : _ref$children,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TextSmall, _extends({}, others, {
    color: inverse ? 'teal' : 'neutral',
    "data-teamleader-ui": "help-text",
    marginTop: 1,
    tint: inverse ? 'light' : 'darkest',
    ref: ref
  }), children);
});
HelpText.displayName = 'HelpText';
export default HelpText;